import type { ClientView } from '@gazette/shared';
import { locale, t } from '../i18n/index.ts';
import { renderGazette } from './gazette.ts';
import { loadCanvasFonts } from './text.ts';

// The souvenir: the full edition with every verdict stamped, every author signed and the
// night's results, carrying the game's name for whoever sees it in a group chat.

async function gazetteFile(current: ClientView): Promise<File> {
  await loadCanvasFonts();
  const results = current.phase.name === 'final' ? current.phase.results : null;
  const { canvas } = renderGazette({
    gazette: current.gazette!,
    players: current.players,
    locale: locale.value,
    verdicts: current.verdicts,
    results,
    footer: `${t('gz.footer')} · ${location.host}`,
  });
  const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob((value) => (value ? resolve(value) : reject(new Error('toBlob'))), 'image/png'));
  return new File([blob], `la-gazette-${current.code.toLowerCase()}-${current.gazette!.edition}.png`, { type: 'image/png' });
}

export async function downloadGazette(current: ClientView): Promise<void> {
  const file = await gazetteFile(current);
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.name;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export function canShareFiles(): boolean {
  const probe = new File([''], 'probe.png', { type: 'image/png' });
  return typeof navigator.canShare === 'function' && navigator.canShare({ files: [probe] });
}

export async function shareGazette(current: ClientView): Promise<void> {
  const file = await gazetteFile(current);
  try {
    await navigator.share({ files: [file], title: t('app.name'), text: t('final.shareText') });
  } catch {
    // The player closed the share sheet.
  }
}
